
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/uslugi-dodatkowe/rozmowy-miedzynarodowe/podsumowanie",
      function () {
        return require("private-next-pages/moje-konto/uslugi-dodatkowe/rozmowy-miedzynarodowe/podsumowanie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/uslugi-dodatkowe/rozmowy-miedzynarodowe/podsumowanie"])
      });
    }
  